<template>
    <div class="box">
        <div class="content-box">
            <div class="title" @click="visible = true">{{ branch ? branch.name : "点击选择门店" }}</div>
            <div v-for="(item, index) in lastWeekUserTops" :key="index" :class="`top-item top-item-${index}`">
                <div class="avatar-box"></div>
                <img :src="item.avatar" class="avatar-img" />
                <div class="mc">
                    <div class="text">{{ item.nickname || "&nbsp;"}}</div>
                    UID:{{ item.uid || "&nbsp;"}}
                </div>
                <div class="num-box">
                    <NumText :num="item.total_change_quantity" :type="index | getType" />
                </div>
            </div>
            <template v-for="(item, index) in lastMonthBranchTops">
                <div :class="`top-item month top-item-${index}`" v-if="index == 0">
                <div class="avatar-box"></div>
                <img :src="item.avatar" class="avatar-img" />
                <div class="mc">
                    <div class="text">{{ item.nickname || "&nbsp;"}}</div>
                    UID:{{ item.uid || "&nbsp;"}}
                </div>
                <div class="num-box">
                    <NumText :num="item.total_change_quantity" :type="index | getType" />
                </div>
                </div>
            </template>
            
            
            <div class="now-list-box">
                <div v-for="(item, index) in nowWeekUserTops" :key="index" class="now-list-item">
                    <NumText :num="index + 1" />
                    <div class="now-avatar-nickname">
                        <div class="now-avatar">
                            <div class="now-avatar-box"></div>
                            <img :src="item.avatar" />
                        </div>
                        <div class="nickname">{{ item.nickname }}</div>
                    </div>
                    <div style="width:200rem">{{ item.uid }}</div>
                    <div style="width:250rem;"><span style="color:#ff6567">{{ item.total_change_quantity }}</span>分</div>
                </div>
            </div>
            <div class="time">更新时间：{{ updateTimeStr }} &nbsp;&nbsp;&nbsp; 下次更新时间：{{ nextUpdateTimeStr }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 本周排名每10分钟更新一次</div>
        </div>
        <a-modal title="选择门店" :visible="visible" @cancel="visible = false" :footer="null">
            <a-button v-for="(item, index) in branches" :key="index" @click="setBranch(item)" class="branch-btn">{{
                item.name }}</a-button>
        </a-modal>
    </div>
</template>
<script>
import NumText from '@/components/NumText'
import { getBranches, getBranchTop } from '@/api/wx'
import moment from 'moment'
export default {
    name: 'Top',
    components: {
        NumText
    },
    filters: {
        getType(value) {
            let str = ["g", "y", "j"]
            return str[value]
        }

    },
    data() {
        return {
            visible: false,
            branches: [],
            branch: null,
            lastWeekUserTops: [],
            nowWeekUserTops: [],
            lastMonthBranchTops:[],
            timeID:0,
            updateTimeStr:"",
            nextUpdateTimeStr:"",
        }
    },
    watch: {
        branch: {
            handler(val) {
                this.getBranchTop()
            },
        }
    },
    mounted() {
        getBranches().then(res => {
            this.branches = res.list.filter(item => item.visible)
        })
        let {
            branch_id,
            name
        } = this.$route.query
        if (branch_id && name) {
            this.branch = {
                id: branch_id,
                name
            }
        }else{
            let branch = localStorage.getItem('topBranch')
            if (branch) {
                this.branch = JSON.parse(branch)
            }
        }
    },
    destoryed() {
        this.removeWindowTime()
    },
    methods: {
        getBranchTop() {
            if (this.branch) {
                getBranchTop(this.branch.id).then(res => {
                    this.lastWeekUserTops = res.lastWeekUserTops || []
                    this.nowWeekUserTops = res.nowWeekUserTops || []
                    this.lastMonthBranchTops = res.lastMonthBranchTops || []
                    this.updateTimeStr = moment().format('HH:mm:ss')
                    this.nextUpdateTimeStr = moment().add(10+60*10,"s").format('HH:mm:ss')
                    this.removeWindowTime()
                    this.bindWindowTime()
                })
            }
        },
        setBranch(item) {
            let branch = {
                id: item.id,
                name: item.name
            }
            this.branch = branch
            this.visible = false
            localStorage.setItem('topBranch', JSON.stringify(branch))
        },

        bindWindowTime() {
            this.timeID = setInterval(() => {
                this.getBranchTop()
            }, 1000 * 60 * 10 + 10000)
        },
        removeWindowTime() {
            clearInterval(this.timeID)
        },
    }
}
</script>
<style scoped lang="less">
.box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
}

.content-box {
    width: 1920rem;
    height: 1080rem;
    background: url("../../assets/top/background.jpg") no-repeat;
    background-size: 100%;
    position: relative;
}

.title {
    position: absolute;
    top: 70rem;
    left: 117rem;
    font-size: 32rem;
    line-height: 38rem;
    color: #a2413f;
    font-weight: bold;
    cursor: pointer;
    width: 480rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.branch-btn {
    margin: 0 12px 12px 0;
}

.top-item {
    position: absolute;
    text-align: center;
    .text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 70%;
        margin: 0 auto;
    }
}

.avatar-box {
    position: absolute;
    z-index: 1;
}

.avatar-img {
    position: absolute;
    border-radius: 50%;
    z-index: 0;
}

.mc {
    position: absolute;
}

.month{
    transform-origin: top left;
}

.top-item-0 {
    width: 335rem;
    height: 491rem;
    left: 1245rem;
    top: 0;
    background: url("../../assets/top/flag_1.png") no-repeat;
    background-size: 100%;
    z-index:1;
    &.month{
        top: 115rem;
        left: 93rem;
        transform: scale(0.73);
    }

    .avatar-img {
        width: 80rem;
        height: 80rem;
        top: 182rem;
        left: 50%;
        margin-left: -41rem;
    }

    .avatar-box {
        background: url("../../assets/top/avatarFrame_1.png") no-repeat;
        width: 179rem;
        height: 145rem;
        top: 146rem;
        left: 50%;
        margin-left: -91rem;
        background-size: 100%;
    }

    .mc {
        width: 212rem;
        height: 80rem;
        top: 288rem;
        left: 50.5%;
        margin-left: -106rem;
        background: url("../../assets/top/name_1.png") no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        line-height: 40rem;
        font-weight: bold;
        font-size: 18rem;
        color: #B2420B;

        .text {
            font-size: 25rem;
            padding-top: 5rem;
            line-height: 35rem;
        }
    }

    .num-box {
        margin: 390rem auto 0;
        height: 43rem;
        padding-left: 61rem;
        background: url("../../assets/top/integralWords_1.png") no-repeat;
        background-size: 59rem 34rem;
        background-position: left center;
        display: inline-block;
    }
}

.top-item-1 {
    width: 284rem;
    height: 423rem;
    left: 952rem;
    top: 29rem;
    background: url("../../assets/top/flag_2.png") no-repeat;
    background-size: 100%;
    z-index:0;
    &.month{
        top: 156rem;
        left: 104rem;
        transform: scale(0.74);
    }

    .avatar-img {
        width: 60rem;
        height: 60rem;
        top: 148rem;
        left: 50%;
        margin-left: -28rem;
    }

    .avatar-box {
        background: url("../../assets/top/avatarFrame_2.png") no-repeat;
        width: 103rem;
        height: 111rem;
        top: 119rem;
        left: 50%;
        margin-left: -48rem;
        background-size: 100%;
    }

    .mc {
        width: 190rem;
        height: 72rem;
        top: 230rem;
        left: 51%;
        margin-left: -95rem;
        background: url("../../assets/top/name_2.png") no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        line-height: 36rem;
        font-weight: bold;
        font-size: 16rem;
        color: #99583e;

        .text {
            font-size: 23rem;
            padding-top: 4rem;
            line-height: 32rem;
        }
    }

    .num-box {
        margin: 340rem auto 0;
        height: 37rem;
        padding-left: 59rem;
        background: url("../../assets/top/integralWords_2.png") no-repeat;
        background-size: 57rem 32rem;
        background-position: left center;
        display: inline-block;
    }
}

.top-item-2 {
    width: 284rem;
    height: 427rem;
    left: 1584rem;
    top: 31rem;
    background: url("../../assets/top/flag_3.png") no-repeat;
    background-size: 100%;
    z-index:0;
    &.month{
        top: 160rem;
        left: 508rem;
        transform: scale(0.74);
    }

    .avatar-img {
        width: 60rem;
        height: 60rem;
        top: 148rem;
        left: 50%;
        margin-left: -27rem;
    }

    .avatar-box {
        background: url("../../assets/top/avatarFrame_3.png") no-repeat;
        width: 103rem;
        height: 113rem;
        top: 119rem;
        left: 50%;
        margin-left: -47rem;
        background-size: 100%;
    }

    .mc {
        width: 188rem;
        height: 72rem;
        top: 230rem;
        left: 51%;
        margin-left: -94rem;
        background: url("../../assets/top/name_3.png") no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        line-height: 36rem;
        font-weight: bold;
        font-size: 16rem;
        color: #7a5049;

        .text {
            font-size: 23rem;
            padding-top: 4rem;
            line-height: 32rem;
        }
    }

    .num-box {
        margin: 340rem auto 0;
        height: 37rem;
        padding-left: 59rem;
        background: url("../../assets/top/integralWords_3.png") no-repeat;
        background-size: 57rem 32rem;
        background-position: left center;
        display: inline-block;
    }
}

.now-list-box {
    position: absolute;
    right: 22rem;
    top: 542rem;
    width: 1046rem;
    font-size: 32rem;
    font-weight: bold;
}

.now-list-item {
    height: 71rem;
    display: flex;
    align-items: center;
    color: #af3b3c;
    padding-left: 80rem;
    text-align: center;
}

.now-avatar-nickname {
    flex: 1;
    padding-left: 68rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .nickname{
        max-width: 280rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .now-avatar {
        width: 75rem;
        height: 72rem;
        position: relative;
        margin-right:30rem;
        .now-avatar-box {
            position: absolute;
            width: 75rem;
            height: 72rem;
            background: url("../../assets/top/avatarFrame.png") no-repeat;
            background-size: 100%;
            top:0;
            left:0;
            z-index: 1;
        }

        img {
            width:44rem;
            height:44rem;
            position: absolute;
            bottom:12rem;
            right:16rem;
            z-index: 0;
            border-radius: 50%;
        }
    }

}
.time{
    position: absolute;
    bottom:0;
    left:852rem;
    font-size:30rem;
    color:#fff;
}
</style>